import ItiButton from "@/iti-core-react/components/ItiButton/ItiButton.tsx";
import { SortDirection } from "@/shared/dtos/page-types";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

const SORT_DIRECTION_CONFIG = {
	ASC: { id: 1, icon: "mdi mdi-sort-alphabetical-ascending" },
	DESC: { id: 2, icon: "mdi mdi-sort-alphabetical-descending" },
};

interface SortOrderButtonProps {
	sortDirection: SortDirection;
	onSortDirectionChange: (order: SortDirection) => void;
}

export default function SortDirectionButton({
	sortDirection,
	onSortDirectionChange,
}: SortOrderButtonProps) {
	const { t } = useTranslation();

	const sortDirectionConfig = useMemo(() => {
		const isAscending = sortDirection === SortDirection.ASC;
		return {
			icon: isAscending
				? SORT_DIRECTION_CONFIG.ASC.icon
				: SORT_DIRECTION_CONFIG.DESC.icon,
			hint: isAscending
				? t("catalogue.sort_ascending")
				: t("catalogue.sort_descending"),
		};
	}, [sortDirection, t]);

	const handleSortDirectionChange = useCallback(() => {
		onSortDirectionChange(
			sortDirection === SortDirection.ASC
				? SortDirection.DESC
				: SortDirection.ASC,
		);
	}, [sortDirection]);

	return (
		<ItiButton
			className="sort-direction-button"
			stylingMode="text"
			icon={sortDirectionConfig.icon}
			hint={sortDirectionConfig.hint}
			onClick={handleSortDirectionChange}
		/>
	);
}
